/* eslint-disable */
import React from 'react'
import Page from '../../Component/Pagination/Pagination'
import http from '../../Component/Interceptor/Interseptor'
import HeaderTable from '../BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import {message} from 'antd'
import jMoment from 'moment-jalaali'
import {accounting} from 'accounting'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import $ from 'jquery'
import cookie from 'react-cookies'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import FromToPicker from '../BaseComponent/FromToPicker'
import {productShop} from '../../lib/path'

class UnMatchDeliveryPackAll extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      printInfo: [],
      unMatch: [],
      buttonClicked: false,
      fromDate: '',
      toDate: ''
    }
  }

  getUnmatches = (
    pageNumber = sessionStorage.getItem('pageNumber'),
    pageSize = sessionStorage.getItem('dropDownVal'),
    params = sessionStorage.getItem('params')
  ) => {
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_INCOMPATIBLE_ALL
        }?export=false&pageNumber=${pageNumber}&pageSize=${pageSize}&${params}`,
        {}
      )
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()

          this.setState({
            unMatch: response.data.object.result,
            buttonClicked: true,
            countAll: response.data.object.countAll
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
        }
      })
  }
  componentDidMount() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
  }

  onResultFetched(data) {
    this.setState({
      unMatch: data
    })
  }

  changeDropDown(data) {
    this.setState({
      unMatch: data,
      countAll: this.state.countAll
    })
  }

  filter() {
    var minDate = this.state.fromDate
    var maxDate = this.state.toDate
    if (minDate === '' && maxDate === '') {
      message.error('حداقل یک فیلتر وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      this.setState({
        toPrintDate: minDate == '' ? '-' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
        fromPrintDate: maxDate == '' ? '-' : jMoment(this.state.toDate).format('jYY/jMM/jDD')
      })
      sessionStorage.setItem('params', `dateMin=${minDate}&dateMax=${maxDate}`)
      sessionStorage.setItem('pageNumber', 1)
      this.getUnmatches()
    }
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  getPrintInfo = () => {
    http
      .get(
        `${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_INCOMPATIBLE_ALL}?export=true&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        if (response.data.error === null) {
          // alert(JSON.stringify(response.data))
          this.setState({
            printInfo: response.data.object.result,
            aggregation: response.data.object.aggregation
          })
          setTimeout(() => {
            window.print()
          }, 2000)
        } else {
          // message.error(response.data.description)
        }
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
  }

  exportExcel = () => {
    http
      .get(
        `${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_INCOMPATIBLE_ALL}?export=true&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['websiteTakhfif'] = Number(excelReport[i]['websiteDiscountAmount'])
            excelReport[i]['providerTakhfif'] = Number(excelReport[i]['providerDiscountAmount'])
          }
          this._export.save(this.state.excelReport)
        }
      })
  }

  render() {
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let urlParams = sessionStorage.getItem('params')
    let pageNumber = sessionStorage.getItem('pageNumber')
    let reporterName = cookie.load('name')
    let printCol = [
      'ردیف',
      'تامین کننده',
      'نام محصول',
      'کد محصول',
      'بارکد محصول',
      'تعداد در سفارش',
      'تعداد ورودی به انبار بارانداز',
      'تعداد در پارت تحویل',
      'تعداد تحویل شده به مشتری'
    ]

    return (
      <div className="rtl printA4Page">
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش مغایرت کالاها.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'providerName'}
                field={'product.providerName'}
                title={'تامین کننده'}
                width="300px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'productName'}
                field={'product.productName'}
                title={'نام محصول'}
                width="400px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'articleId'}
                field={'product.articleId'}
                title={'کد محصول'}
                width="130px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'productCode'}
                field={'product.productCode'}
                title={'بارکد محصول'}
                width="130px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'supplyOrderQuantity'}
                field={'supplyOrderQuantity'}
                title={'تعداد در سفارش'}
                width="130px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'cardexQuantity'}
                field={'cardexQuantity'}
                title={'تعداد ورودی به انبار بار انداز'}
                width="130px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'deliveryQuantity'}
                field={'deliveryQuantity'}
                title={'تعداد در پارت تحویل'}
                width="130px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'detailQuantity'}
                field={'detailQuantity'}
                title={'تعداد تحویل شده به مشتری'}
                width="130px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش مغایرت کالا ها در سیستم"
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              headerColSpan={9}
              rightColSpan={4}
              centerColSpan={2}
              leftColSpan={3}
              centerSection={''}
              rightSection={
                'تاریخ از : ' +
                (this.state.toPrintDate === undefined ? '' : this.state.toPrintDate) +
                ' تا ' +
                (this.state.fromPrintDate === undefined ? '' : this.state.fromPrintDate)
              }
              columns={printCol}
            />

            <tbody>
              {this.state.printInfo.map((list, index) => (
                <tr key={'i' + index} style={index % 2 == 0 ? {backgroundColor: '#f1f1f1'} : {backgroundColor: '#fff'}}>
                  <td>{index + 1}</td>
                  <td>{list.product.providerName}</td>
                  <td>{list.product.productName}</td>
                  <td>{list.product.articleId}</td>
                  <td>{list.product.productCode}</td>
                  <td>{list.supplyOrderQuantity}</td>
                  <td>{list.cardexQuantity}</td>
                  <td>{list.deliveryQuantity}</td>
                  <td>{list.detailQuantity}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارش عمومی</li>
            <li>گزارش مغایرت کالاها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  printUrl=""
                  url={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_INCOMPATIBLE_ALL}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printComponent={this.printTable}
                  execelUrl={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_INCOMPATIBLE_ALL + '?export=true'}
                  excelColumns={[]}
                  titleAdd=""
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ از"
                  toLabel="تاریخ تا"
                  defaulValue={true}
                  fromId="from"
                  toId="to"
                />
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>تامین کننده</td>
                    <td>نام محصول</td>
                    <td>کد محصول</td>
                    <td>بارکد محصول</td>
                    <td>تعداد در سفارش</td>
                    <td>تعداد ورودی به انبار بارانداز</td>
                    <td>تعداد در پارت تحویل</td>
                    <td>تعداد تحویل شده به مشتری</td>
                  </tr>
                  {this.state.unMatch.map((list, index) => (
                    <tr
                      key={index}
                      style={
                        list.supplyOrderQuantity !== list.cardexQuantity ||
                        list.deliveryQuantity !== list.detailQuantity
                          ? {backgroundColor: '#fdcccc'}
                          : {}
                      }
                    >
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{list.product.providerName}</td>
                      <td>
                        <a target="_blank" href={productShop({articleId: list.product.articleId})}>
                          {list.product.productName}
                        </a>
                      </td>
                      <td>{list.product.articleId}</td>
                      <td>{list.product.productCode}</td>
                      <td>{list.supplyOrderQuantity}</td>
                      <td>{list.cardexQuantity}</td>
                      <td>{list.deliveryQuantity}</td>
                      <td>{list.detailQuantity}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.countAll}
                  onResultFetched={this.onResultFetched.bind(this)}
                  url={REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_INCOMPATIBLE_ALL}
                  urlParams={urlParams}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default UnMatchDeliveryPackAll
